<!--
 * @Description: 互动解锁组件
 * @Author: dezhi
 * @Date: 2019-08-09 13:47:18
 * @LastEditTime: 2020-11-18 09:58:21
 * @LastEditors: dezhi
 -->
<template>
  <section>
    <a-row>
      <a-col :span="12">
        <h3>准 考 证</h3>
        <table>
          <tr>
            <td>报考证书</td>
            <td colspan="2">{{ examInfo.certificationName }}</td>
          </tr>
          <tr>
            <td>评定科目</td>
            <td colspan="2">{{ examInfo.subject }}</td>
          </tr>
          <tr>
            <td>评定时间</td>
            <td colspan="2">{{ examInfo.examStartdate }}</td>
          </tr>
          <tr>
            <td colspan="3"></td>
          </tr>
          <tr>
            <td>准考证号</td>
            <td>{{ examInfo.admissionNo }}</td>
            <td rowspan="5" style="position: relative">
              <img :src="examInfo.enrollImageURL" width="180" />
              <img
                class="seal"
                v-if="isAc"
                src="@/assets/images/fai.jpg"
                width="160"
              />
            </td>
          </tr>
          <tr>
            <td>姓名</td>
            <td>{{ examInfo.idname }}</td>
          </tr>
          <tr>
            <td>性别</td>
            <td>{{ examInfo.gender }}</td>
          </tr>
          <tr>
            <td>证件类型</td>
            <td>{{ type[examInfo.idpaperType - 1] }}</td>
          </tr>
          <tr>
            <td>证件号码</td>
            <td>{{ examInfo.idno }}</td>
          </tr>
          <tr>
            <td colspan="3"></td>
          </tr>
          <tr>
            <td>考点</td>
            <td colspan="2">{{ examInfo.areaName }}</td>
          </tr>
          <tr>
            <td>考场名称</td>
            <td colspan="2">{{ examInfo.examVenue }}</td>
          </tr>
          <tr>
            <td>考场地址</td>
            <td colspan="2">{{ examInfo.examLocation }}</td>
          </tr>
          <tr>
            <td>考场号</td>
            <td colspan="2">{{ examInfo.examRoom }}</td>
          </tr>
          <tr>
            <td>座位号</td>
            <td colspan="2">{{ examInfo.seatNo }}</td>
          </tr>
        </table>
      </a-col>
      <a-col :span="12">
        <h3>应考人员考场守则</h3>
        <div class="rules">
          <p>
            1、评定开始前45分钟，应考人员凭本人准考证和报名时使用的有效身份证件（大陆居民可凭居民身份证，香港、澳门、台湾居民可凭港澳台居民来往内地/大陆通行证或港澳台居民居住证，无身份证者可凭由公安部门签发的在有效期内的有效临时居民身份证明参加评定，其他证件均属无效。）进入指定考场，接受监考人员核对证件，以确认应考人员本人到场。凡是两证不全或与报名时使用的有效证件不一致者，一律不得进入考场。
          </p>
          <p>
            2、应考人员进入考场时，除本人准考证、有效身份证件和签字笔外，不准携带其它物品进入考场。已随身携带的其它物品应按照要求存放在指定的物存放处（携带的通讯工貝、电子设备等应全部关闭后，再存放在指定的物存放处）。
          </p>
          <p>
            3、应考人员须按准考证上指定的座位号对号入座，不得随意调换座位。入座后，须将准考证和有效身份证件放在评定桌面左上角，以备监考人员检查。
          </p>
          <p>
            4、应考人员入座后，不得擅自离开考场。如果有特殊情况需要暂时离开考场，应当由监考人员陪同。在同一考场同一时间，只允许1名应考人员暂时离开考场。
          </p>
          <p>
            5、评定开始前，应考人员可使用准考证号登录评定系统，登录后应仔细核对姓名、性别、准考证号、有效身份证件号及评定科目，并仔细阅读《评定须知》。应考人员如发现信息有误，应举手向监考人员示意，并听从监考人员的安排进行现场处理。
          </p>
          <p>
            6、监考人员发出开始评定指令后，应考人员方可开始答卷。评定开始30分钟后，应考人员不得进入考场。开考30分钟内未能在评定机上登录并确认的应考人员，视为缺考，评定系统将不再接受该准考证号登录。评定开始60分钟后，应考人员方可交卷离开。
          </p>
          <p>
            7、评定过程中，如出现评定机故障、网络故障或供电故障等异常情况，致应考人员无法正常评定，应考人员应举手示意，并听从监考人员安排。
          </p>
          <p>
            8、因评定机故障等客观原因致应考人员答题时间出现损失，应考人员可以当场向监考人员提出补时要求，由监考人员根据上海国家会计学院相关规定予以处理。
          </p>
          <p>
            9、应考人员须自觉遵守考场秩序，保持安静，不准吸烟或吃东西。如因疾病等原因不能坚持评定的，应报告监考人员，监考人员将根据貝体情况进行处理。
          </p>
          <p>
            10、评定结束前，应考人员由于违规行为或特殊情况须离场处理的，应当经监考人员批准，在《考场情况记录表》中填写交卷时间并签字后方可离开评定地点。
          </p>
          <p>
            11、评定结束时，系统将自动收卷，应考人员应按提示安静退场。提前结束评定退场者不得在考场附近逗留、喧哗。
          </p>
          <p>
            12、所有评定的试题内容，均属于上海国家会计学院版权所有，应考人员未经授权，不得以任何方式或理由将试题内容进行抄录、复制、传播。
          </p>
          <p>
            13、应考人员如出现违规行为，将按照《税务管理师CTM（初级）专业能力评定违规违纪行为处理办法（试行）》相关规定处理。有关处理情况上海国家会计学院将在其官方网站、学习网站以公告形式或其他方式予以发布。
          </p>
          <p>14、本守则自2020年1月1日起施行。</p>
        </div>
      </a-col>
    </a-row>
  </section>
</template>

<script>
/* eslint-disable */
export default {
  data() {
    return {
      type: ["身份证", "临时身份证", "护照", "港澳通行证", "台湾通行证"],
    };
  },
  props: ["isAc", "examInfo"],
  mounted() {
    // this.getImage(this.examInfo.enrollImageURL, "avatar");
  },
  methods: {},
};
</script>

<style scoped>
section {
  position: relative;
  padding: 30px;
  background: #fff;
}
.seal {
  position: absolute;
  top: 50%;
  right: -80px;
}
h3 {
  margin-bottom: 40px;
  text-align: center;
  font-weight: bold;
  font-size: 24px;
}
table {
  width: 100%;
  border: 1px solid #333;
}
tr {
  height: 41px;
}
td {
  text-align: center;
  border: 1px solid #333;
  color: #000;
}
.rules {
  padding-left: 20px;
  font-size: 12px;
  line-height: 1.4em;
  color: #000;
}
.rules p {
  margin-bottom: 5px;
}
</style>
